import { render, staticRenderFns } from "./ngn_wallet.vue?vue&type=template&id=797b6439&"
import script from "./ngn_wallet.vue?vue&type=script&lang=js&"
export * from "./ngn_wallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports